export type MMDataChances = {
  status: 'success' | 'warning' | 'support';
  text: string;
};
export const dataChances: Record<string, MMDataChances> = {
  'very-high': {
    status: 'success',
    text: 'Chance alta de aprovação',
  },
  high: {
    status: 'success',
    text: 'Chance alta de aprovação',
  },
  medium: {
    status: 'support',
    text: 'Chance média de aprovação',
  },
  low: {
    status: 'warning',
    text: 'Chance baixa de aprovação',
  },
  unknown: {
    status: 'warning',
    text: 'Chance baixa de aprovação',
  },
};
